<template>
  <div>
      老哥啊 大发慈悲啊 我瞅瞅咋回事1
    <div class="box">
      <van-image
        :src="src"
        class="inner-img"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Test1",
  props: {
    src: {
      type: String,
      default: require('@/assets/images/xiaoshouyuan@2x.png'),
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
.box {
  overflow: hidden;
  width: 500px;
  height: 500px;
  margin: 0 auto;
  margin-right: 10px;
  ::v-deep .van-image__img {
    width: 100%;
    margin-bottom: 6px;
    position: relative;
    left: -600px;
    filter: drop-shadow(600px 0 var(--tc));
  }
}
</style>
